<template>
  <div>
    <a-modal
      :title="audit ? '调薪申请' : '调薪申请详情'"
      :visible="is_show"
      width="60%"
      @cancel="is_show = false"
      :maskClosable="false"
      class="gufiiguy"
    >
      <template slot="footer">
         <a-button type="primary" @click="downloadData" style="float: left"> 导出 </a-button>
        <a-button key="back" @click="is_show = false"> 取消 </a-button>
        <a-button type="danger" @click="reject(3)" v-if="audit"> 驳回 </a-button>
        <a-button key="submit" type="primary" @click="reject(1)" v-if="audit"> 转交 </a-button>
        <a-button key="submit" type="primary" @click="reject(2)" v-if="audit"> 通过 </a-button>
      </template>
      <div ref="sadsada">
        <a-form-model :model="info" :label-col="labelCol3" :wrapper-col="wrapperCol3">
          <div class="title">
            <span>基本信息</span>
          </div>
          <div class="content">
            <a-row>
              <a-col :span="24">
                <a-form-model-item
                  label="审批标题"
                  class="model_span_form"
                  :label-col="{ span: 3 }"
                  :wrapper-col="{ span: 21 }"
                >
                  <span>{{ info.title }}</span>
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="24">
                <a-form-model-item
                  label="审批编号"
                  class="model_span_form"
                  :label-col="{ span: 3 }"
                  :wrapper-col="{ span: 21 }"
                >
                  <span>{{ info.applyCode }}</span>
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="24">
                <a-form-model-item
                  label="抄送人"
                  class="model_span_form"
                  :label-col="{ span: 3 }"
                  :wrapper-col="{ span: 21 }"
                >
                  <span>{{ info.ccName }}</span>
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="8">
                <a-form-model-item
                  label="部门"
                  class="model_span_form"
                  :label-col="labelCol2"
                  :wrapper-col="wrapperCol2"
                >
                  <span>{{ info.userDeptName }}</span>
                </a-form-model-item>
              </a-col>
              <a-col :span="8">
                <a-form-model-item
                  label="姓名"
                  class="model_span_form"
                  :label-col="labelCol2"
                  :wrapper-col="wrapperCol2"
                >
                  <span>{{ info.name }}</span>
                </a-form-model-item>
              </a-col>
              <a-col :span="8">
                <a-form-model-item
                  label="工号"
                  class="model_span_form"
                  :label-col="labelCol2"
                  :wrapper-col="wrapperCol2"
                >
                  <span>{{ info.jobNumber }}</span>
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="8">
                <a-form-model-item
                  label="岗位名称"
                  class="model_span_form"
                  :label-col="labelCol2"
                  :wrapper-col="wrapperCol2"
                >
                  <span>{{ info.post }}</span>
                </a-form-model-item>
              </a-col>
              <a-col :span="8">
                <a-form-model-item
                  label="原薪资(元)"
                  class="model_span_form"
                  :label-col="labelCol2"
                  :wrapper-col="wrapperCol2"
                >
                  <span v-if="info.or" @click="changeorF" style="color: dodgerblue; cursor: pointer">{{
                    info.originalSalary
                  }}</span>
                  <span v-else @click="changeorT" style="color: dodgerblue; cursor: pointer">{{
                    returnTelHide(info.originalSalary)
                  }}</span>
                </a-form-model-item>
              </a-col>
              <a-col :span="8">
                <a-form-model-item
                  label="原薪资大写(元)"
                  class="model_span_form"
                  :label-col="labelCol2"
                  :wrapper-col="wrapperCol2"
                >
                  <span v-if="info.OR" @click="changeORF" style="color: dodgerblue; cursor: pointer">{{
                    info.originalCapital
                  }}</span>
                  <span v-else @click="changeORT" style="color: dodgerblue; cursor: pointer">{{
                    returnTelHide(info.originalCapital)
                  }}</span>
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="8">
                <a-form-model-item
                  label="调整后薪资(元)"
                  class="model_span_form"
                  :label-col="labelCol2"
                  :wrapper-col="wrapperCol2"
                >
                  <span v-if="info.ad" @click="changeadF" style="color: dodgerblue; cursor: pointer">{{
                    info.adjustedSalary
                  }}</span>
                  <span v-else @click="changeadT" style="color: dodgerblue; cursor: pointer">{{
                    returnTelHide(info.adjustedSalary)
                  }}</span>
                </a-form-model-item>
              </a-col>
              <a-col :span="8">
                <a-form-model-item
                  label="调整后薪资大写(元)"
                  class="model_span_form"
                  :label-col="labelCol2"
                  :wrapper-col="wrapperCol2"
                >
                  <span v-if="info.AD" @click="changeADF" style="color: dodgerblue; cursor: pointer">{{
                    info.adjustedCapital
                  }}</span>
                  <span v-else @click="changeADT" style="color: dodgerblue; cursor: pointer">{{
                    returnTelHide(info.adjustedCapital)
                  }}</span>
                </a-form-model-item>
              </a-col>
              <a-col :span="8">
                <a-form-model-item
                  label="调整月份"
                  class="model_span_form"
                  :label-col="labelCol2"
                  :wrapper-col="wrapperCol2"
                >
                  <span>{{ info.adjustedMonth }}</span>
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="24">
                <a-form-model-item
                  label="调薪原因"
                  class="model_span_form"
                  :label-col="{ span: 3 }"
                  :wrapper-col="{ span: 21 }"
                >
                  <span>{{ info.reason }}</span>
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="8">
                <a-form-model-item label="附件">
                  <div
                    class="view_path"
                    @click="previewFile(item)"
                    v-for="(item, index) in info.attachment"
                    :key="index"
                  >
                    {{ item.name }}
                  </div>
                </a-form-model-item>
              </a-col>
            </a-row>
          </div>
          <div class="title" v-if="!audit && recordNumber==1">
          <span>审批记录</span>
        </div>
        <div class="content" v-if="!audit && recordNumber==1">
          <auditModel ref="auditModel"></auditModel>
        </div>
        </a-form-model>
      </div>
       
    </a-modal>
    <!-- 撤销提示 -->
    <preview ref="preview" />
    <a-modal
      v-model="is_revocation"
      :title="result == 3 ? '确认驳回此申请吗?' : '确认通过此申请吗?'"
      on-ok="handleOkReason"
    >
      <template slot="footer">
        <a-button key="back" @click="is_revocation = false"> 取消 </a-button>
        <a-button key="submit" type="primary" :loading="loading" @click="handleOkReason" v-if="result == 3">
          驳回
        </a-button>
        <a-button key="submit" type="primary" :loading="loading" @click="handleOkReason" v-if="result == 2">
          通过
        </a-button>
      </template>
      <a-textarea placeholder="请输入原因" v-model="comment" />
    </a-modal>
    <transferModal ref="transferModal" @sure="handleSure" />
  </div>
</template>
<script>
import { downLoadPdf  } from '@/utils/index'
import auditModel from './audit.vue'
import { salary_adjustment_exportPdf, business_fee_apply_downlodPdf } from '@/api/activiti'
import { resolveBlob } from '@/utils/index'
import { axios } from '@/utils/request'
import { salary_adjustment_get } from '@/api/financial'
import { getClaimByBusiness, act_task_audit } from '@/api/activiti'
import { act_sku_num } from '@/api/assetmenag'
import { checkPermission } from '@/utils/permissions'
import preview from '@/components/module/prview'
import transferModal from '@/views/activiti/modules/TransferModal.vue'
import Watermark from '../../../utils/watermark'
import { VueAxios } from '@/utils/axios'
import axios_s from 'axios'
import storage from 'store'
 const exportBaseUrl = process.env.VUE_APP_EXPORT_BASE_URL
import {
  ACCESS_TOKEN
} from '@/store/mutation-types'
export default {
  props: {
    audit: {
      type: Boolean,
      default: true,
    },
  },
  components: {
    preview,
    transferModal,
    auditModel
  },
  data() {
    return {
      recordNumber: 0,
      is_revocation: false,
      result: '',
      comment: '', //驳回原因
      is_show: false,
      info: {},
      labelCol: {
        span: 6,
      },
      wrapperCol: {
        span: 16,
      },
      labelCol2: {
        span: 9,
      },
      wrapperCol2: {
        span: 15,
      },
      labelCol3: {
        span: 9,
      },
      wrapperCol3: {
        span: 15,
      },
      record: null,
      assetsExportConsumables: checkPermission('asset:claim:checkSku'),
    }
  },
  activated() {},
  watch: {},
  created() {},
  mounted() {
    console.log(this.assetsExportConsumables)
  },
  methods: {
    	//导出
		downloadData() {
			downLoadPdf('/act/salary_adjustment/export_pdf?businessKey=' + this.record.businessKey,)
    },
    //薪资调整导出
    download() {

       salary_adjustment_exportPdf ({
        businessKey: this.record.businessKey,
      }).then((res) => {
        // resolveBlob(res,this.get_file_type[type])
        console.log(res.data, 'res.data===========================')
        // window.open(`http://47.114.172.13:8888/file/download?bucketName=${tmp}&path=''&fileName=${}`)
         window.open(exportBaseUrl + '/file/download?path=' + res.data)
      })

    },
    changeADT() {
      this.info['AD'] = true
      this.$forceUpdate()
    },
    changeADF() {
      this.info['AD'] = false
      this.$forceUpdate()
    },
    changeadT() {
      this.info['ad'] = true
      this.$forceUpdate()
    },
    changeadF() {
      this.info['ad'] = false
      this.$forceUpdate()
    },
    changeORT() {
      this.info['OR'] = true
      this.$forceUpdate()
    },
    changeORF() {
      this.info['OR'] = false
      this.$forceUpdate()
    },
    changeorT() {
      this.info['or'] = true
      this.$forceUpdate()
    },
    changeorF() {
      this.info['or'] = false
      this.$forceUpdate()
    },
    handleSure() {
      this.is_show = false
      this.$emit('ok')
    },
    //预览文件
    previewFile(file) {
      console.log(file)
      //预览文件
      let path = '/' + file.url.split('/')[0] + '/'
      let fileName = file.url.substring(file.url.indexOf('/') + 1)
      axios_s.post(
        process.env.VUE_APP_API_BASE_URL+`/file/file/download?bucketName=${file.types}&path=${path}&fileName=${fileName}`,
        {},
        {
          responseType: 'blob',
          headers: {
			  'token' : storage.get(ACCESS_TOKEN),
			  'Content-Type':'application/json'
		  },
        }
      ).then((res) => {
      	  console.log(res)
      	  var file_s_n=file.name.split('.')
      	let type=file_s_n[file_s_n.length-1]
      	console.log(this.get_file_type[type])

          // this.imgUrl = window.URL.createObjectURL(res)
          resolveBlob(res,this.get_file_type[type]) //新窗口打开，借用浏览器去打印
        })
      //   axios({
      //     url:`/file/file/download?bucketName=${file.types}&path=${path}&fileName=${fileName}`,
      //     method: 'post',
      //     responseType: 'blob', // 必须要写
      //   }).then((res) => {
      // 	  console.log(res)
      // 	  var file_s_n=file.name.split('.')
      // 	let type=file_s_n[file_s_n.length-1]
      // 	console.log(this.get_file_type[type])

      //     // this.imgUrl = window.URL.createObjectURL(res)
      //     resolveBlob(res,this.get_file_type[type]) //新窗口打开，借用浏览器去打印
      //   })
    },
    show_img(idx, imgs) {
      var row = {
        index: idx,
        imgs: imgs,
      }
      this.$refs.preview.show(row)
    },
    show(record, type = null) {
      this.recordNumber = record.recordNumber
      this.record = record
      salary_adjustment_get(record.businessKey).then((res) => {
        console.log(res)
        if (res.code != 200) {
          this.$message.error(res.msg)
          return
        }
        this.info = res.data
        console.log(this.info, 'this.info, ???????????????????????????????????????????')
        this.info['or'] = false
        this.info['OR'] = false
        this.info['ad'] = false
        this.info['AD'] = false
        this.is_show = true
        this.$nextTick(() => {
          Watermark.set('安联云管家', this.$refs.sadsada)
           if(!this.audit && this.recordNumber==1) {
                 this.$refs.auditModel.show(record)
               }
        })
      })
    },
    //驳回
    reject(result_) {
      if (result_ == 1) {
        this.$refs.transferModal.show({
          record: this.record,
        })
      } else {
        this.is_revocation = true
        this.comment = ''
        this.result = result_
      }
    },
    handleOkReason() {
      if (this.result == 3) {
        if (this.comment == '') {
          this.$message.error('请输入驳回意见！')
        } else {
          this.succeed(this.result)
        }
      } else if (this.result == 2) {
        this.succeed(this.result)
      }
    },
    //审批
    succeed(result_) {
      act_task_audit({
        taskId: this.record.id,
        procDefKey: this.record.processDefKey,
        procInstId: this.record.procInstId,
        procName: this.record.processName,
        applyer: this.record.applyer,
        result: result_,
        businessKey: this.record.businessKey,
        comment: this.comment,
      }).then((res) => {
        if (res.code != 200) {
          this.$message.error(res.msg)
          return
        }
        this.$message.success('审批成功')
        this.$emit('ok')
        this.is_show = false
        this.is_revocation = false
      })
    },
  },
}
</script>
<style lang="less" scoped>
/deep/ .content {
  padding-left: 10px !important;
}
/deep/ .ant-form-item-label {
  text-align: left;
}
</style>